import { Menubar } from "@/components/ui/menubar";
import { memo, PropsWithChildren } from "react";
import QueryTableColumnsMenuBarMenu from "./QueryTableColumnsMenuBarMenu";
import QueryTableSettingsMenuBarMenu from "./QueryTableSettingsMenuBarMenu";
import QueryTableToolsMenuBarMenu from "./QueryTableToolsMenuBarMenu";
import { cn } from "@/lib/utils";

interface QueryTableMenubarProps extends PropsWithChildren {
  className?: string;
}

interface QueryTableMenubarComponent
  extends React.MemoExoticComponent<React.FC<QueryTableMenubarProps>> {
  Tools: typeof QueryTableToolsMenuBarMenu;
  Columns: typeof QueryTableColumnsMenuBarMenu;
  Settings: typeof QueryTableSettingsMenuBarMenu;
}

export const QueryTableMenubar = memo(
  ({ children, className }: QueryTableMenubarProps) => {
    return <Menubar className={cn("mb-2", className)}>{children}</Menubar>;
  },
) as QueryTableMenubarComponent;

QueryTableMenubar.Tools = QueryTableToolsMenuBarMenu;
QueryTableMenubar.Columns = QueryTableColumnsMenuBarMenu;
QueryTableMenubar.Settings = QueryTableSettingsMenuBarMenu;
